export enum ViewName {
   KIT_ITEMS = 1,
   ADD_TO_KIT = 2,
}
